// extracted by mini-css-extract-plugin
export default {"frames-control":"lsf-frames-control","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385756
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  